import React, { Component } from 'react';
import Box from '@mui/material/Box';
import $ from 'jquery';
import Checkbox from '@mui/material/Checkbox';

export default class Smartest extends Component {
	
	constructor(props){
        super(props)
		this.state = {
            itemArray:[],
        }
        this.shoot = this.shoot.bind(this); 		
    }
	
	componentDidMount(){
		let options = this.props.data.options.split(',');
		if(options){
			let opArray = [];
			options.map(function(val,i) {
				let optionKey = val.split('|');
				opArray.push(optionKey[1]);
			})
			
			let optionSorted = [];
			if(this.props.data.optionSorting == "preserveOrder"){
				optionSorted = this.preserveOrder(opArray);
			}else if(this.props.data.optionSorting == "randomize"){
				optionSorted = this.randomizeOrder(opArray);
			}else if(this.props.data.optionSorting == "alphaNum"){
				optionSorted = this.alphaNumSort(opArray);
			}
			
			this.setState({preOption: optionSorted});
		}
	}
	
	shoot(event) {
        const item = event.target.name;
        const isChecked = event.target.checked;
        const value =event.target.value;
        let itemArray = this.state.itemArray
        let sh = {name:item, value:value, isChecked:isChecked};
		
        if(isChecked==true){
            itemArray.push(value)
        }else{
            if(itemArray.indexOf(value) !==-1){
                itemArray = itemArray.filter(e => e !== value)
            }
        }
		
		let min = this.props.data.minOpselection;
		let max = this.props.data.maxOpselection;
		
		if(min && itemArray.length < min){
			alert('You must select minimum '+min+' and maximum '+max+' options.');
		}
		
		if(max && itemArray.length > max){
			alert('You must select minimum '+min+' and maximum '+max+' options.');
			return false;
		}
		
		let itemString = itemArray.toString();
		this.setState({itemArray});
		this.props.func(this.props.data.fieldId,itemString);
    }
	
	preserveOrder(arr) {
	  return [...arr]; // Return a shallow copy to preserve original
	}

	randomizeOrder(arr) {
	  return [...arr].sort(() => Math.random() - 0.5); // Fisher-Yates is better for large arrays
	}

	alphaNumSort(arr) {
	  return [...arr].sort((a, b) => {
		return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
	  });
	}


	render() {
		const {data} = this.props;
		const {preOption} = this.state;
		let id = data.fieldId;
		let kioskResponse = data.kioskResponse;
		let ts = '';
        if(kioskResponse.size > 0){
            let resAns = kioskResponse.get(id)
            if(resAns !== undefined){
                ts = resAns.split(',');
            }
        }
		let optionsHtml = '';
		if(preOption){
			optionsHtml = preOption.map(function(val,i) {
				//let name = 'action'+i;
				if(ts.indexOf(val) !== -1){
					return (<Box key={i}><Checkbox value={val} checked={true} name={val} sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} /> {val}</Box>);  
				}else{
					return (<Box key={i}><Checkbox value={val} checked={false} name={val} sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} /> {val}</Box>);
                }
			})
		}
		
		return (<div onChange={this.shoot} className="ver-checkbox">
		   {optionsHtml}
		</div>);
	}
}
